// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","loaderContainer":"circles-loader_loaderContainer__QhDRm","loaderCircle":"circles-loader_loaderCircle__XBAuh","active":"circles-loader_active__cRSti"};